<template>
  <div class="column_center_center payment_type_popup">
    <div class="column_center_start payment_type_container">
      <text class="title" style="color: #fd5001; margin-bottom: 20px"
        >選擇付款方式</text
      >

      <!-- 付款方式單選 -->
      <div class="payment_radio_group">
        <label
          class="radio-option"
          :class="{ disabled: disableLinePay }"
          v-if="linePayPaymentMethod"
          @click="selectPayment('linePay')"
        >
          <input
            v-model="selectedPaymentType"
            class="radio-input"
            type="radio"
            value="linePay"
            :disabled="disableLinePay"
          />
          <div
            class="picker"
            :class="{ selected: selectedPaymentType === 'linePay' }"
          ></div>
          <div class="row_center_center pay_badge">Pay</div>
          <span
            >LinePay<span v-if="disableLinePay" class="disabled_hint"
              >（0 元訂單不可使用）</span
            ></span
          >
        </label>
        <label
          class="radio-option"
          :class="{ disabled: disableJkoPay }"
          v-if="jkoPayPaymentMethod"
          @click="selectPayment('jkoPay')"
        >
          <input
            v-model="selectedPaymentType"
            class="radio-input"
            type="radio"
            value="jkoPay"
            :disabled="disableJkoPay"
          />
          <div
            class="picker"
            :class="{ selected: selectedPaymentType === 'jkoPay' }"
          ></div>
          <img
            :src="jkoPayIcon"
            class="jko_pay_icon"
            alt=""
            aria-hidden="true"
          />
          <span
            >街口支付<span v-if="disableJkoPay" class="disabled_hint"
              >（0 元訂單不可使用）</span
            ></span
          >
        </label>
        <label
          class="radio-option"
          v-if="isCashPaymentEnabled"
          @click="selectPayment('cash')"
        >
          <input
            v-model="selectedPaymentType"
            class="radio-input"
            type="radio"
            value="cash"
          />
          <div
            class="picker"
            :class="{ selected: selectedPaymentType === 'cash' }"
          ></div>
          <span>店家自訂支付</span>
        </label>
      </div>

      <!-- 付款說明文字 -->
      <div
        v-if="isCashPaymentEnabled && customPaymentText"
        class="custom-payment-description mt-5"
      >
        <div class="custom-payment-inner">
          <div>店家自訂支付說明：</div>
          <div v-html="customPaymentText"></div>
        </div>
      </div>

      <!-- 下方按鈕：返回 / 送出訂單 -->
      <div class="retail_action_row mt-5">
        <button class="button retail_cancel" @click="close">返回</button>
        <button
          class="button retail_submit"
          :disabled="!selectedPaymentType"
          @click="submitOrder"
        >
          送出訂單
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import jkoPayIcon from "@/assets/jkopay_icon.png";

export default {
  props: {
    disableLinePay: {
      type: Boolean,
      default: false,
    },
    disableJkoPay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedPaymentType: "", // '' | 'linePay' | 'jkoPay' | 'cash'
      jkoPayIcon,
    };
  },
  computed: {
    geturlParameters() {
      return this.$route.params;
    },
    linePayPaymentMethod() {
      return this.$store.getters["payment/linePayPaymentMethod"];
    },
    isCashPaymentEnabled() {
      return this.$store.getters["payment/isCashPaymentEnabled"];
    },
    jkoPayPaymentMethod() {
      return this.$store.getters["payment/jkoPayPaymentMethod"];
    },
    customPaymentText() {
      return this.$store.getters["basic/customPaymentText"];
    },
  },
  watch: {
    disableLinePay(val) {
      if (val && this.selectedPaymentType === "linePay") {
        this.selectedPaymentType = "";
      }
    },
    disableJkoPay(val) {
      if (val && this.selectedPaymentType === "jkoPay") {
        this.selectedPaymentType = "";
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    selectPayment(type) {
      if (type === "linePay" && this.disableLinePay) return;
      if (type === "jkoPay" && this.disableJkoPay) return;
      this.selectedPaymentType = type;
    },
    submitOrder() {
      if (!this.selectedPaymentType) return;
      if (this.selectedPaymentType === "linePay") {
        this.$emit("linePay");
      } else if (this.selectedPaymentType === "jkoPay") {
        this.$emit("jkoPay");
      } else {
        this.$emit("cashPay");
      }
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss">
/* 遮罩 / 容器 / .button / .custom-payment-* 沿用 paymentTypePopup.vue 的全域 scss */

/* 單選群組（沿用 takeOutEdit.vue 的 radio 樣式） */
.payment_radio_group {
  width: 85%;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.payment_radio_group .radio-option {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 500;
  color: #000;
  cursor: pointer;
  user-select: none;
}

.payment_radio_group .radio-option.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.payment_radio_group .disabled_hint {
  font-size: 13px;
  color: #FD5001;
  font-weight: 400;
  margin-left: 4px;
}

.payment_radio_group .radio-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.payment_radio_group .picker {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #aaaaaa;
  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment_radio_group .picker.selected {
  border-color: #facb00;
  border-width: 2px;
}

.payment_radio_group .picker.selected::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #facb00;
}

/* LinePay 小綠底「Pay」標記 */
.payment_radio_group .pay_badge {
  padding: 3px 7px;
  background-color: #03bf5b;
  color: #fff;
  border-radius: 4px;
  font-weight: 900;
  font-size: 14px;
}

/* 街口圖示，文字沿用付款選項的 18px 字級 */
.payment_radio_group .jko_pay_icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex-shrink: 0;
}

/* 下方取消 / 送出訂單 */
.retail_action_row {
  width: 85%;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.retail_action_row .button {
  width: 50%;
  margin: 0;
}

.retail_cancel {
  background-color: #dddddd;
}

.retail_submit {
  background-color: #facb00;
  color: #fff;
}

.retail_submit:disabled {
  background-color: #facb00;
  opacity: 0.7;
}
</style>
